import React, {useEffect} from 'react';
import {useDownloadURL} from "react-firebase-hooks/storage";
import {firebaseStorage, storageRef} from "../firebase/client-app";
import reactImageSize from 'react-image-size';

const ShowImage = ({mode, src, width, style, selectedImage, setImageSize, setSelectedImage}) => {
    const [value, loading, error] = useDownloadURL(storageRef(firebaseStorage, src));

    useEffect(() => {
        if (value && !(selectedImage?.width || selectedImage?.height)) {
            reactImageSize(value)
                .then(({width, height}) => {
                    setImageSize({
                        width: width,
                        height: height
                    });

                    const existingImage = {...selectedImage};
                    existingImage.width = width;
                    existingImage.height = height;
                    setSelectedImage(existingImage);
                })
                .catch((errorMessage) => {
                    console.log('errorMessage: ', errorMessage);
                });
        }
    }, [value]);

    let modes = {
        'fill': 'cover',
        'fit': 'contain'
    };
    let size = modes[mode] || 'contain';

    let defaults = {
        height: 300,
        width: width || 300,
        backgroundColor: 'bg-white',
    };

    let important = {
        backgroundImage: `url("${src}")`,
        backgroundSize: size,
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat'
    };

    return (
        <>
            {!loading && value &&
                <div
                    className="shadow-lg bg-white hover:bg-neutral-400 rounded p-8">
                    <div style={{
                        ...defaults, backgroundSize: size,
                        backgroundPosition: 'center center',
                        backgroundRepeat: 'no-repeat',
                        backgroundImage: `url("${value}")`
                    }}/>
                </div>
            }
        </>
    )
}

export default ShowImage
